import { IonItem, IonLabel, IonSelect, IonSelectOption } from "@ionic/react"
import React from "react"

interface Props {
  value: string
  onChange: (value: string) => void
}

const FormName: React.FC<Props> = (props) => {
  return (
    <IonItem>
      <IonLabel position="floating">Bezeichnung</IonLabel>

      <IonSelect
        value={props.value}
        okText="Wählen"
        cancelText="Abbrechen"
        onIonChange={e => props.onChange((e.target as HTMLInputElement).value)}
      >
        <IonSelectOption value="Abstellgebäude">Abstellgebäude</IonSelectOption>
        <IonSelectOption value="Carport">Carport</IonSelectOption>
        <IonSelectOption value="Doppelgarage">Doppelgarage</IonSelectOption>
        <IonSelectOption value="Garage">Garage</IonSelectOption>
        <IonSelectOption value="Gartenhaus">Gartenhaus</IonSelectOption>
        <IonSelectOption value="Holzhütte">Holzhütte</IonSelectOption>
        <IonSelectOption value="Sauna">Sauna</IonSelectOption>
      </IonSelect>
    </IonItem>
  )
}

export default FormName
